import i18n from '@/i18n';

export default {
  computed: {
    subscriptionItems() {
      return [
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.with_subscription'),
          value: 1,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.without_subscription'),
          value: 0,
        },
        {
          text: i18n.t('subscription.ended_2_weeks_ago'),
          value: 2,
        },
      ];
    },
  },
};
